import { Dropdown, MenuProps, Tooltip } from 'antd'
import useAuth from 'hooks/useAuth'
import useDirectory from 'hooks/useDirectory'

import DropdownIconCustom from 'components/icons/DropdownIconCustom'

type Props = {
  t: any
}

export default function UserDropdown({ t }: Props) {
  const { profile, logout } = useAuth()
  const nameCharacterLength =
    (profile?.lastName || '').length + (profile?.firstName || '').length

  const { navigate, getDirectory } = useDirectory()

  const getUserName = () => {
    if (profile?.lastName && profile.firstName) {
      if (profile.lastName.length > 10) {
        return `${profile.lastName.slice(0, 10)}...`
      }

      if (nameCharacterLength > 10) {
        return `${`${profile.lastName}  ${profile.firstName}`.slice(0, 12)}...`
      }

      return `${profile.lastName}  ${profile.firstName}`
    }
    return ''
  }

  const items = [
    {
      label: t('user.setting'),
      key: 'setting',
      excludeFrom: [],
      onClick: () => navigate(`/users/me`)
    },
    {
      label: t('translation.information'),
      key: 'information',
      excludeFrom: ['bcp', 'tour'],
      onClick: () => window.open('https://info.digi-tori360.com/ ', '_blank')
    },
    {
      label: t('translation.contactUs'),
      key: 'contactUs',
      excludeFrom: [],
      onClick: () => navigate(`/contact-us`)
    },
    {
      label: t('user.logout'),
      key: 'logout',
      excludeFrom: [],
      onClick: logout
    }
  ]

  const dropdownItems: MenuProps['items'] = items
    .filter((item) => !item.excludeFrom.some((ex) => ex === getDirectory()))
    .map((item) => ({
      label: item.label,
      key: item.key,
      onClick: item.onClick
    }))

  return profile ? (
    <Dropdown
      menu={{ items: dropdownItems }}
      trigger={['click']}
      placement="bottomLeft"
      overlayClassName={`${getDirectory()}-theme`}
      className="custom-user-dropdown min-w-40"
    >
      <div className="flex h-full items-center gap-4 justify-end cursor-pointer pr-5">
        <Tooltip
          title={
            nameCharacterLength > 10
              ? `${profile.lastName}  ${profile.firstName}`
              : ''
          }
        >
          <div className="text-white text-[14px] font-[500]">
            {getUserName()}
          </div>
        </Tooltip>
        <div className="w-4 flex items-center">
          <DropdownIconCustom colorIcon="white" />
        </div>
      </div>
    </Dropdown>
  ) : null
}
